import { Image } from 'antd';
import { Users } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, ConvertToCharacter, FileUploadChild, convertToNumber, deleteData, encryptPassword, sanitizeInput } from "../CommonComponents/CustomHooks";
import { getFileNameAndExtension, initializeFilterData } from "../CommonComponents/EnvConfig";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { AutoCompleteBoxNew, FormButton, InputBox, Switch } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";
const ComapanyMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false)
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const initialFormData = {
        "companyID": "",
        "bCode": "",
        "companyCode": "System Generated",
        "companyShortName": "",
        "companyName": "",
        "companyAddress": "",
        "pinCode": "",
        "city": "",
        "state": "",
        "emailID": "",
        "mobileNo": "",
        "contactPerson": "",
        "gstNo": "",
        "panNo": "",
        "active": true,
        companyLogoImage: "",
        companyLogoName: "",
        companyLogoExt: ""
    }
    const [formData, setFormData] = useState(initialFormData);

    const getComapanyMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/Master/ShowCompanyMaster`, data)
        if (res.Status === 'SUCCESS') {
            setTableData(res)
        }
        if (res.Status === 'ERROR') {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = () => {
        setFormData({
            ...initialFormData,
        });
        filterData.SearchText = '';
        inputrefs.current['txtCompanyShortName'].focus()
        setIsEdit(false)
        getComapanyMasterData();
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/Master/InsertUpdateCompanyMaster`, { ...formData, password: encryptPassword(formData.password) })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data?.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        await setIsEdit(true);
        let editData = await ApiCall(`/api/Master/EditCompanyMaster`, { companyID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'SUCCESS') {
            await inputrefs.current[editData?.focus].focus();
            setFormData((pre) => ({
                ...pre, ...editData,
            }))
        } else {
            await NotificationSound(editData.status, editData.message, editData?.focus, inputrefs);
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/Master/DeleteCompanyMaster`, { companyID: id }, getComapanyMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleChange1 = (i, p) => {
        getComapanyMasterData(p)
    };

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };


    const GetPinCodeDetails = async (value) => {
        const res = await ApiCall(`/api/Master/GetCityStateByPincode`, { pincode: value });
        if (res.status === 'SUCCESS') {
            setFormData({
                ...formData,
                state: res.state,
                pinCode: value,
                city: res.city
            })
        } else {
            setFormData({
                ...formData,
                state: "",
                city: "",
                pinCode: value
            })
        }
    };

    useEffect(() => {
        document.title = 'Company Master'
        inputrefs.current['txtCompanyShortName'].focus()
    }, [])



    useEffect(() => {
        getComapanyMasterData();
    }, [sortConfig]);

    return (
        <>
            <div className='bg-secondary-50 shadow-lg rounded-md p-3'>
                <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-2">
                        <Users className="w-5 h-5 text-primary-600" />
                        <h2 className="text-xl font-semibold text-primary-600">Company Master</h2>
                    </div>
                </div>
                <div className="card-body grid grid-cols-1 md:grid-cols-4 gap-3">

                    <InputBox
                        id="txtCompanyCode"
                        label="Company Code"
                        placeholder="Enter Company Code"
                        value={formData.companyCode}
                        disabled
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtCompanyShortName'].focus()
                            }
                        }}
                    />

                    <InputBox
                        id="txtCompanyShortName"
                        label="Short Name"
                        placeholder="Enter Short Name"
                        required
                        value={formData.companyShortName}
                        onChange={(e) =>
                            setFormData({ ...formData, companyShortName: sanitizeInput(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtCompanyName'].focus()
                            }
                        }}
                    />

                    <InputBox
                        id="txtCompanyName"
                        label="Company Name"
                        placeholder="Enter Company Name"
                        required
                        value={formData.companyName}
                        onChange={(e) =>
                            setFormData({ ...formData, companyName: sanitizeInput(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtContactPerson'].focus()
                            }
                        }}
                    />

                    <InputBox
                        id="txtContactPerson"
                        label="Contact Person"
                        required
                        placeholder="Enter Contact Person"
                        value={formData.contactPerson}
                        onChange={(e) =>
                            setFormData({ ...formData, contactPerson: ConvertToCharacter(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtMobileNo'].focus()
                            }
                        }}
                    />

                    <InputBox
                        id="txtMobileNo"
                        label="Mobile No"
                        placeholder="Enter Mobile No"
                        required
                        maxLength="10"
                        value={formData.mobileNo}
                        onChange={(e) =>
                            setFormData({ ...formData, mobileNo: convertToNumber(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtEmailID'].focus()
                            }
                        }}
                    />

                    <InputBox
                        id="txtEmailID"
                        label="Email ID"
                        placeholder="Enter Email ID"
                        required
                        value={formData.emailID}
                        onChange={(e) =>
                            setFormData({ ...formData, emailID: sanitizeInput(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtCompanyAddress'].focus()
                            }
                        }}
                    />

                    <InputBox
                        id="txtCompanyAddress"
                        label="Address"
                        placeholder="Enter Address"
                        value={formData.companyAddress}
                        required
                        onChange={(e) =>
                            setFormData({ ...formData, companyAddress: sanitizeInput(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtPinCode'].focus()
                            }
                        }}
                    />


                    <AutoCompleteBoxNew
                        id="txtPinCode"
                        label="Pincode"
                        required
                        placeholder="Enter Pincode"
                        autocompleteType="GetPinCode"
                        value={formData.pinCode || ""}


                        onChange={async (event, newInputValue) => {
                            newInputValue = newInputValue || ''
                            if (event.type !== 'keydown') {
                                setFormData({ ...formData, pinCode: newInputValue })
                                await GetPinCodeDetails(newInputValue)
                            }
                        }}
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtState'].focus()
                            }
                        }}
                    />


                    <AutoCompleteBoxNew
                        id="txtState"
                        required
                        label="State"
                        placeholder="Select State"
                        autocompleteType="GetState"
                        value={formData.state}

                        onChange={async (event, newInputValue) => {
                            newInputValue = newInputValue || ''
                            if (event.type !== 'keydown') {
                                setFormData({ ...formData, state: newInputValue })
                            }
                        }}
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtCity'].focus()
                            }
                        }}
                    />

                    <AutoCompleteBoxNew
                        id="txtCity"
                        label="City"
                        placeholder="Select City"
                        required
                        autocompleteType="GetCity"
                        contextKey={formData.state}
                        value={formData.city}

                        onChange={async (event, newInputValue) => {
                            newInputValue = newInputValue || ''
                            if (event.type !== 'keydown') {
                                setFormData({ ...formData, city: newInputValue })
                            }
                        }}
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtGSTNo'].focus()
                            }
                        }}
                    />
                    <InputBox
                        id="txtGSTNo"
                        label="GST No"
                        placeholder="Enter GST No"
                        required
                        value={formData.gstNo}
                        onChange={(e) =>
                            setFormData({ ...formData, gstNo: sanitizeInput(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtPANNo'].focus()
                            }
                        }}
                    />
                    <InputBox
                        id="txtPANNo"
                        label="PAN No"
                        placeholder="Enter PAN No"
                        value={formData.panNo}
                        onChange={(e) =>
                            setFormData({ ...formData, panNo: sanitizeInput(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtActive'].focus()
                            }
                        }}
                    />
                    <div className="w-full">
                        <label className="mb-px text-[12px] font-medium text-gray-900">
                            Upload Document<span className='text-red-500'></span>
                        </label>
                        <FileUploader
                            classes="upload-section file-uploader mt-2"
                            handleChange={(file) => {
                                if (file.size < 2 * 1024 * 1024) {
                                    const fileData = getFileNameAndExtension(file.name);
                                    const reader = new FileReader();
                                    reader.readAsDataURL(file);
                                    reader.onload = () => {
                                        const base64 = reader.result.split(',')[1];
                                        setFormData({
                                            ...formData,
                                            companyLogoImage: base64,
                                            companyLogoName: fileData.name,
                                            companyLogoExt: fileData.extension
                                        });
                                    };
                                } else {
                                    NotificationSound('ERROR', 'Size must be under 2mb!');
                                }
                            }}
                            name="file"
                            types={["Jpg", "Png",]}
                            children={
                                <FileUploadChild
                                    label=''
                                    message={formData.companyLogoName + '.' + formData.companyLogoExt}
                                    types={["Jpg", "Png",]}
                                />
                            }
                        />

                        <span className="text-red-500 text-xs font-bold">Size must be under 2mb</span>
                    </div>
                    {formData.companyLogoImage && (
                        <div className="w-full mt-3">
                            {formData.companyLogoImage && (
                                <div className="w-full flex items-center gap-3">
                                    <div className="p-1 border rounded-xl shadow-sm bg-gray-50">
                                        <Image
                                            width={100}

                                            className="rounded-xl object-cover"
                                            src={`data:image/${formData.companyLogoExt.toLowerCase()};base64,${formData.companyLogoImage}`}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    <Switch
                        id="txtActive"
                        label="Active"
                        divclassname='w-full mt-[25px]'
                        checked={formData.active}
                        onChange={(e) =>
                            setFormData({ ...formData, active: e.target.checked })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['btnSub'].focus()
                            }
                        }}
                    />

                </div>

                <div className='card-body'>
                    <FormButton
                        id={'btnSub'}
                        inputrefs={inputrefs}
                        handleSubmit={handleSubmit}
                        handleExport={async () => {
                            await dispatch(setSubLoading(true))
                            handleDownloadExcel(`/api/Master/ShowCompanyMaster`, filterData, 'Company Master')
                            await dispatch(setSubLoading(false))
                        }}
                        handleClear={handleClear}
                    />
                </div>
            </div>

            <div className="mt-3">
                <Table
                    handleEdit={handleEditData}
                    handleDelete={handleDelete}
                    loading={isLoading}
                    PageName={'CompanyMaster'}
                    handleFilter={() => {
                        getComapanyMasterData()
                        setFilterData({
                            ...filterData,
                        })
                    }}
                    filterData={filterData}
                    tableData={tableData}
                    setFilterData={setFilterData}
                    currentPageNo={currentPageNo}
                    handleChange1={handleChange1}
                    sortConfig={sortConfig}
                    handleSorting={handleSorting}
                />
            </div>

        </>
    )
}
export default ComapanyMaster;